import { render } from "./Create.vue?vue&type=template&id=bf5f682a"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/AreaProjects/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf5f682a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf5f682a', __exports__)) {
    console.log('reload')
    api.reload('bf5f682a', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=bf5f682a", () => {
    console.log('re-render')
    api.rerender('bf5f682a', render)
  })

}


export default __exports__